'use client';

import { Input  } from '@chakra-ui/react';
import type { InputProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import type { FormBaseInputProps, FormValues } from '../../../types';
import { FormFloatingFieldText } from '../../wrapper/FormFloatingFieldText/FormFloatingFieldText';

type CounterProps = {
	maxChars?: number
};

export type TextInputProps<T> = FormBaseInputProps<T> & Omit<InputProps, 'name'> & CounterProps;

export const TextInput = <T extends FormValues>({
	helperText,
	label,
	maxChars,
	name,
	optionalText,
	required,
	...textInputProps
}: TextInputProps<T>) => {
	const { register } = useFormContext<T>();

	return (
		<FormFloatingFieldText
			helperText={helperText}
			label={label}
			maxChars={maxChars}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Input
				{...register(name)}
				maxLength={typeof maxChars === 'number' ? maxChars : undefined}
				{...textInputProps}
			/>
		</FormFloatingFieldText>
	);
};
